import { useI18n } from '@change-corgi/core-react/i18n';
import { useNavigate } from '@change-corgi/core-react/router';
import { useTracking } from '@change-corgi/core-react/tracking';

import type { SessionUser } from '#src/shared/session';

import { usePetitionActionsPageData, usePetitionActionsPageState } from '#src/app/pages/actions/pageContext';
import { useCurrentUser } from '#src/app/shared/hooks/session';

const COMMENT_MIN_LENGTH = 10;

type Result = ModelHookResult<
	{
		buttonTextCopy: string;
		buttonTextGuestCopy: string;
		currentUser: SessionUser | undefined;
	},
	{
		handleLoginButtonClick: () => void;
		handleAddVoiceButtonClick: () => void;
	}
>;

type Props = {
	text: string;
	shareVoice: (text: string) => void;
};
export function useSupporterVoicesButton({ text, shareVoice }: Props): Result {
	const currentUser = useCurrentUser();
	const {
		data: {
			petition: { slug },
		},
	} = usePetitionActionsPageData();

	const [, { setShareSupporterVoiceError }] = usePetitionActionsPageState();

	const track = useTracking();
	const { translate } = useI18n();
	const navigate = useNavigate();

	const handleLoginButtonClick = () => {
		navigate(`/login_or_join?redirectTo=/p/${slug}/actions`);
	};

	const handleAddVoiceButtonClick = () => {
		void track('action_page_add_voice_click', {
			text,
		});
		if (text.trim().length < COMMENT_MIN_LENGTH) {
			setShareSupporterVoiceError(
				translate('corgi.petition_actions.supporter_voice_text.errors.min_length', {
					minLength: COMMENT_MIN_LENGTH,
				}),
			);
			void track('action_page_add_voice_validation_error', {
				text,
			});
		} else {
			shareVoice(text);
		}
	};

	return {
		data: {
			buttonTextCopy: translate('corgi.petition_actions.supporter_voice_text.submit_button.label'),
			buttonTextGuestCopy: translate('corgi.petition_actions.supporter_voice_text.log_in_button.label'),
			currentUser,
		},
		actions: {
			handleLoginButtonClick,
			handleAddVoiceButtonClick,
		},
	};
}
